import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";

//查询列表 POST /simShipmentBatch/findList
export  const findList =(page,params)=>{
    return http.postJSON("/simShipmentBatch/findList?"+jsonToFormData(page),params);
  }

//新增 POST /simShipmentBatch/insert
export function add(params){
    return http.postJSON("/simShipmentBatch/insert",params);
  }

//编辑 POST /simShipmentBatch/edit
export function edit(params){
    return http.postJSON("/simShipmentBatch/edit",params);
  }

  //GET /simShipmentBatch/exportExcel
  export function exportExcel(params) {
    return http.getExcel("/simShipmentBatch/exportExcel",params,"导出")
 }

/**
 * 下载采购记录导出导入模板（批次号、sim卡号段）。
 *
 * @returns {Promise} Excel 文件
 */
export function downloadBatchManagementTemplate() {
  return http.getExcel("/simShipmentBatch/downloadBatchManagementTemplate")
}

/**
 * 提交采购记录异步导出任务。
 *
 * @param {Object} params 筛选条件与导出字段
 * @returns {Promise<Object>} 提交结果
 */
export function batchManagementExportTask(params) {
  return http.postJSON("/simShipmentBatch/export/task", {...params})
}

/**
 * 按导入模板提交采购记录异步导出。
 *
 * @param {Object} payload 导出字段
 * @param {File} file 模板文件
 * @returns {Promise<Object>} 提交结果
 */
export function batchManagementExportTaskByTemplate({exports}, file) {
  return http.postFormData("/simShipmentBatch/export/task", {
    file,
    exports: JSON.stringify(exports || [])
  })
}


 //获取供应商 /simShipmentBatch/findSupplierNameList
 export function findSupplierNameList(){
  return http.postJSON("/simShipmentBatch/findSupplierNameList",{});
}


//供应商列表/simShipmentBatch/supplier/pageQuery
export  const pageQuery =(page,params)=>{
  return http.postJSON("/simShipmentBatch/supplier/pageQuery?"+jsonToFormData(page),params);
}

//新增供应商 simShipmentBatch/supplier/insert
export function insert(params){
  return http.postJSON("simShipmentBatch/supplier/insert",params);
}

//编辑供应商
export function update(params){
  return http.postJSON("simShipmentBatch/supplier/update",params);
}



// WEBPACK FOOTER //
// ./src/services/batch.js